// Lightweight email service wrapper for calling the sendEmail Cloud Function
export async function sendEmail({ to, from = 'no-reply@icnacon.org', subject = '', type = 'HTML', body = '' }) {
  const url = 'https://sendemail-s43tpsdbbq-uc.a.run.app';
  
  
  //console.log('[emailService] Sending email:', { to, from, subject }); 
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ to, from, subject, type, body })
    });

    const text = await res.text();
    const contentType = res.headers.get('content-type') || '';
    const data = contentType.includes('application/json') ? JSON.parse(text) : text;

    if (data.status && !data.status) {
      throw new Error(data.error || 'Email service returned an error status');  
    } else {
        //console.log('[emailService] Email sent successfully. Response data:', data);
        return data;
    }

  } catch (err) {
    // Log but don;t throw error as this is complimentary service.
    // (Most callers should treat this as best-effort and not block user flow)
    console.error('[emailService] sendEmail error:', err);
  }
}

export default { sendEmail };
